window.addEventListener('DOMContentLoaded', () => {
	const copyLink = document.getElementById('copy-link');

	if(copyLink) {
		copyLink.addEventListener('click', function() {
			navigator.clipboard.writeText(document.location.href);

			let tooltip = copyLink.getElementsByClassName('tooltip')[0];
			tooltip.classList.add('active');

			setTimeout(function() {
				tooltip.classList.remove('active');
			}, 1500 );
		});
	}
})
